import React from 'react';
import { Weekchoice, Weektxt, DayCheck, DayUncheck } from './style';
import { removeItemByVal } from 'utils/utils.js';
export default function DayOfWeekPicker({updateSelectedItem, selectedItem = []}) {
    
    const dayList = [
        {daytxt :"일", val:"sun"},
        {daytxt :"월", val:"mon"},
        {daytxt :"화", val:"tue"},
        {daytxt :"수", val:"wed"},
        {daytxt :"목", val:"thu"},
        {daytxt :"금", val:"fri"},
        {daytxt :"토", val:"sat"},
    ]
    const handleDayClick = (e) => {
        let selected = e.currentTarget.getAttribute('data-selected');
        let currDay = e.currentTarget.getAttribute('data-val');
        let prevList = selectedItem;
        if(selected === 'true')
        {
            updateSelectedItem(removeItemByVal(prevList, currDay));
        }
        else
        {
            updateSelectedItem([...prevList, currDay]);
        }

    }
    return(
        <Weekchoice>
            {
                dayList.map((value,index)=>{
                    let daySelectorDom = [];
                    if(selectedItem.includes(value['val']) )
                    {
                        daySelectorDom.push(
                        <Weektxt key={`week-day-list-item-id-${value['val']}`}>
                            <DayCheck onClick={handleDayClick} data-val={`${value['val']}`} data-selected='true'>
                                {value.daytxt}
                            </DayCheck>
                        </Weektxt>);
                    }
                    else
                    {
                        daySelectorDom.push(
                        <Weektxt key={`week-day-list-item-id-${value['val']}`}>
                            <DayUncheck onClick={handleDayClick} data-val={`${value['val']}`} data-selected='false'>
                                {value.daytxt}
                            </DayUncheck>
                        </Weektxt>);
                    }
                   return daySelectorDom;
                })
            }
        </Weekchoice>
    );
}